"use client";

import { c as _c } from "react/compiler-runtime";
import { LinkButton } from "@repo/ui/link-button";
import { useTranslations } from "next-intl";
interface DirectoryEmptyStateProps {
  label: string;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}
export function DirectoryEmptyState(t0) {
  const $ = _c(12);
  const {
    label,
    hasActiveFilters,
    onClearFilters
  } = t0;
  const t = useTranslations("directory");
  let t1;
  if ($[0] !== label || $[1] !== t) {
    t1 = t("noResults", {
      label
    });
    $[0] = label;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="typography-body-md-medium text-text-secondary">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== hasActiveFilters || $[6] !== onClearFilters || $[7] !== t) {
    t3 = hasActiveFilters && <LinkButton variant="primary" size="sm" underline={true} onClick={onClearFilters} className="mt-4">{t("clearFilters")}</LinkButton>;
    $[5] = hasActiveFilters;
    $[6] = onClearFilters;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="col-span-full py-16 text-center">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}